import React from 'react'
import {
    Button,
    TextField,
    Popover,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Typography,
} from '@material-ui/core'
import { Container } from '../../Container'
import { useTheme } from '@material-ui/core/styles'
import { TrainingVideoController } from '../../../hooks/useTrainingVideo'

interface AddVideoProps {
    anchorEl: HTMLButtonElement | null
    handleClose: () => void
    setUrl: (url: string) => void
    setCategory: (category: string) => void
    url: string | undefined
    category: string | undefined
    trainingVideoController: TrainingVideoController
}

export const AddVideo = (props: AddVideoProps) => {
    const {
        anchorEl,
        handleClose,
        setUrl,
        setCategory,
        url,
        category,
        trainingVideoController,
    } = props

    const theme = useTheme()
    const handleSave = () => {
        trainingVideoController.addVideo(url || '', category || '')
        handleClose()
    }

    return (
        <Popover
            open={Boolean(anchorEl)}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'center',
            }}
        >
            <Container
                style={{
                    padding: theme.spacing(2),
                    minWidth: 700,
                    flexDirection: 'column',
                }}
            >
                <Typography variant="h6">Add Video</Typography>
                <TextField
                    label="Video URL"
                    value={url}
                    onChange={(e) => setUrl(e.target.value)}
                    variant="outlined"
                    fullWidth
                    style={{ marginTop: theme.spacing(1) }}
                />
                <FormControl
                    variant="outlined"
                    style={{
                        minWidth: 300,
                        marginTop: theme.spacing(2),
                    }}
                >
                    <InputLabel id={`category-label`}>Category</InputLabel>
                    <Select
                        labelId={`category-label`}
                        id={`category-select`}
                        value={category}
                        onChange={(e) => {
                            setCategory(e.target.value as string)
                        }}
                        label="Category"
                        style={{ paddingLeft: theme.spacing(1) }}
                    >
                        {trainingVideoController.categories.map((cat) => (
                            <MenuItem
                                key={`CATEGORY_SELECT__${cat}`}
                                value={cat}
                            >
                                <span>{cat}</span>
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
                <Container
                    style={{
                        marginTop: theme.spacing(2),
                        flex: 1,
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}
                >
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={handleSave}
                    >
                        Save
                    </Button>
                </Container>
            </Container>
        </Popover>
    )
}
